import React, { useContext } from 'react';
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import { Pagination } from "react-bootstrap";

const Pages = observer(() => {
    const { book } = useContext(Context);

      const perPage = book.limit || 1;
      const total = book.totalCount || 0;
      const pageCount = Math.ceil(total / perPage);

    const pages = [];

    for (let i = 0; i < pageCount; i++) {
        pages.push(i + 1);
    }

    if (pageCount <= 1) {
               return null; // одна страница — не рисуем ничего
           }

    return (
        <nav aria-label="Page navigation" className="mt-3">
            <ul className="pagination pagination-sm">
                {pages.map((page) => (
                    <li
                        key={page}
                        className={`page-item ${book.page === page ? 'active' : ''}`}
                        onClick={() => book.setPage(page)}
                        style={{cursor: 'pointer'}}
                    >
                        <span
                            className={`page-link ${book.page === page ? 'bg-success text-white border-success' : 'text-success'}`}
                        >
                            {page}
                        </span>
                    </li>
                ))}
            </ul>

        </nav>

    );
});

export default Pages;
